import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, Typography, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface OnboardingCardProps {
  stepNumber: number;
  title: string;
  description: string;
  icon: React.ReactNode;
  completed?: boolean;
  path: string;
}

export const OnboardingCard: React.FC<OnboardingCardProps> = ({
  stepNumber,
  title,
  description,
  icon,
  completed = false,
  path,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!completed) {
      navigate(path);
    }
  };

  return (
    <Card
      onClick={handleClick}
      sx={{
        height: '100%',
        border: completed ? '2px solid' : '1px solid',
        borderColor: completed ? 'success.main' : 'divider',
        borderRadius: 2,
        position: 'relative',
        transition: 'all 0.2s ease-in-out',
        cursor: completed ? 'default' : 'pointer',
        '&:hover': {
          boxShadow: 3,
          borderColor: completed ? 'success.main' : '#1976d2',
        },
      }}
    >
      {completed && (
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
          }}
        >
          <CheckCircleIcon sx={{ color: 'success.main', fontSize: 28 }} />
        </Box>
      )}

      <CardContent sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500 }}>
          Step {stepNumber}
        </Typography>

        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          {title}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {description}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 2,
            opacity: 0.7,
          }}
        >
          {icon}
        </Box>
      </CardContent>
    </Card>
  );
};

export default OnboardingCard;
